export default __webpack_public_path__ + "static/media/ro.1e4b89db.svg";